/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/UpdateEntityState
 * @desc   Update ExperimentWorkflow entityState
 */

import { ExperimentWorkflowActionUpdateEntityStateModalWizardTrigger as ModalWizardTrigger } from 'labstep-web/components/ExperimentWorkflow/Action/UpdateEntityState/ModalWizard/Trigger';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { Button } from 'labstep-web/core/Button';
import { Icon } from 'labstep-web/core/Icon';
import type { IconProps } from 'labstep-web/core/Icon/types';
import type { EntityState } from 'labstep-web/models/entity-state.model';
import type React from 'react';
import type { ExperimentWorkflowActionUpdateEntityStateProps } from './types';

export const ExperimentWorkflowActionUpdateStatus: React.FC<
  ExperimentWorkflowActionUpdateEntityStateProps
> = ({ experimentWorkflow, iconColor }) => {
  const { hasNextEntityState } = experimentWorkflow;

  if (!hasNextEntityState) {
    return null;
  }

  const nextEntityState =
    experimentWorkflow.nextEntityState as EntityState;

  const actionComponentProps: ActionComponentProps = {
    type: 'children',
    children: ({ status, onClick }) => (
      <Button basic status={status} onClick={onClick}>
        <Icon
          name={nextEntityState.icon as IconProps['name']}
          color={iconColor}
        />{' '}
        {`Mark as ${nextEntityState?.name}`}
      </Button>
    ),
  };

  return (
    <ModalWizardTrigger
      experimentWorkflow={experimentWorkflow}
      actionComponentProps={actionComponentProps}
    />
  );
};
